// extracted by mini-css-extract-plugin
export var disabled = "_16-5";
export var error = "_16-1";
export var fitContent = "_16-6";
export var hasSuffix = "_16-4";
export var iconWrapper = "_16-b";
export var infoIconWrapper = "_16-d _16-b";
export var input = "_16-a";
export var inputWrapper = "_16-0";
export var large = "_16-8";
export var leadingIconWrapper = "_16-c _16-b";
export var measureBox = "_16-e";
export var medium = "_16-7";
export var readonly = "_16-2";
export var small = "_16-3";
export var suffix = "_16-9";